import Swiper from 'swiper';
import { Autoplay, A11y, Pagination } from 'swiper/modules';

export class FrontPageSlider {
  constructor() {
    this.init();
  }

  init() {
    let slides = document.querySelectorAll('.front-page-slider .swiper-slide');
    
    // Sprawdzanie szerokości ekranu i ograniczanie liczby slajdów na mobile
    if (window.innerWidth < 921) {
      slides.forEach((slide, index) => {
        if (index >= 3) {
          slide.remove();
        }
      });
      // Aktualizacja liczby slajdów po usunięciu
      slides = document.querySelectorAll('.front-page-slider .swiper-slide');
    }
    
    const amountOfSlides = slides.length;
    new Swiper('.front-page-slider', {
      modules: [Autoplay, A11y, Pagination],
      loop: amountOfSlides > 1,
      slidesPerView: 1,
      spaceBetween: 10,
      a11y: {
        prevSlideMessage: 'Poprzedni slajd',
        nextSlideMessage: 'Następny slajd',
      },
      pagination: {
        el: '.front-page-swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
      },
    });
  }
}
